// Declare domains that are considered public domains
// Global cache for white label default domains fetched from Azure Key Vault via API
let WL_DEFAULT_DOMAINS_CACHE: string[] | null = null;

export function getWLDefaultDomains(): string[] | null {
    return WL_DEFAULT_DOMAINS_CACHE;
}

export function setWLDefaultDomains(domains: string[]): void {
    WL_DEFAULT_DOMAINS_CACHE = domains;
}
